var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { staticClass: "svg-container" },
    [
      _c("defs", [
        _c(
          "marker",
          {
            attrs: {
              id: "goto-arrow",
              markerWidth: "8",
              markerHeight: "8",
              refX: "8",
              refY: "4",
              orient: "auto",
              markerUnits: "strokeWidth",
            },
          },
          [_c("path", { attrs: { d: "M0,0 L8,4 L0,8 Z", fill: "#ff9800" } })]
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.connectors(), function (path) {
        return _c("path", { key: path.id, attrs: { d: path.path } })
      }),
      _vm._v(" "),
      _vm._l(
        _vm.connectors().filter(function (x) {
          return _vm.isSelected(x.id)
        }),
        function (path) {
          return _c("path", {
            key: path.id + "-selected",
            staticClass: "selected",
            attrs: { d: path.path },
          })
        }
      ),
      _vm._v(" "),
      _vm.gotoPreviewGeom
        ? _c("circle", {
            staticClass: "goto-preview-start",
            attrs: {
              cx: _vm.gotoPreviewGeom.startX,
              cy: _vm.gotoPreviewGeom.startY,
              r: "4",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.gotoPreviewGeom
        ? _c("path", {
            staticClass: "goto-preview",
            attrs: {
              d: _vm.gotoPreviewGeom.path,
              "marker-end": "url(#goto-arrow)",
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }